module.exports = __webpack_public_path__ + "static/img/V_IMG.5d0f35e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Mobile/Mobile_About_Us/V_IMG.png
// module id = g+4x
// module chunks = 0